// src/components/Loader.tsx
const Loader = () => (
  <div className="flex justify-center items-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 sm:w-16 sm:h-16 md:h-24 md:w-24  border-b-4 border-gray-900 dark:border-gray-100"></div>
  </div>
);

export default Loader;
